import React from "react"
import { createRoot } from "react-dom/client"
import App from "./components/App"

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("react-root")
  if (!container) return
  createRoot(container).render(<App />)
})
